import { render, staticRenderFns } from "./SfxOrder.vue?vue&type=template&id=23ecbe96&scoped=true"
import script from "./SfxOrder.vue?vue&type=script&lang=js"
export * from "./SfxOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ecbe96",
  null
  
)

export default component.exports